var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGallery = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#21241E"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.5 22h6c5 0 7-2 7-7V9c0-5-2-7-7-7h-6c-5 0-7 2-7 7v6c0 5 2 7 7 7Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.5 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM3.172 18.95l4.93-3.31a2.25 2.25 0 0 1 2.64.14l.33.29a2.23 2.23 0 0 0 2.82 0l4.16-3.573a2.23 2.23 0 0 1 2.82 0l1.63 1.4"
}))));
export { SvgGallery as ReactComponent };
export default __webpack_public_path__ + "846f3fe6d34f6454745b387c87f9d001.svg";